export const profileAvatarToObject = (avatar = '') => ({
  turtle: 'default',
  facial: avatar.split('-')[1],
  hat: avatar.split('-')[2],
});

export const profileAvatarToString = ({ facial, hat } = {}) => `default-${facial}-${hat}`;
